"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledConditionItems = exports.StyledConditionContent = exports.StyledMenuButtonContainer = exports.StyledItemContent = exports.StyledGroupWrapper = void 0;
const alchemy_ui_1 = require("@m/alchemy-ui");
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledGroupWrapper = styled_components_1.default.div `
  border: 1px solid ${(0, alchemy_ui_1.color)("lineContrast")};
  border-radius: ${(0, alchemy_ui_1.units)(1)};
  padding: ${(0, alchemy_ui_1.units)(1.5)};
`;
exports.StyledItemContent = styled_components_1.default.div `
  flex-grow: 1;
`;
exports.StyledMenuButtonContainer = styled_components_1.default.div `
  position: relative;
  &:before {
    content: '';
    border-left: 1px dashed ${(0, alchemy_ui_1.color)("lineContrast")};
    position: absolute;
    top: -${(0, alchemy_ui_1.units)(1.5)};
    bottom: 50%;
    left: -${(0, alchemy_ui_1.units)(2)};
  }
  &:after {
    content: '';
    border-bottom: 1px dashed ${(0, alchemy_ui_1.color)("lineContrast")};
    position: absolute;
    left: -${(0, alchemy_ui_1.units)(2)};
    width: ${(0, alchemy_ui_1.units)(2)};
    bottom: 50%;
  }
`;
exports.StyledConditionContent = (0, styled_components_1.default)(VerticalStack_1.default) `
  padding-left: ${(0, alchemy_ui_1.units)(2)};
`;
exports.StyledConditionItems = (0, styled_components_1.default)(VerticalStack_1.default) `
  position: relative;
  &:before {
    content: '';
    border-left: 1px dashed ${(0, alchemy_ui_1.color)("lineContrast")};
    position: absolute;
    top: -${(0, alchemy_ui_1.units)(1.5)};
    left: -${(0, alchemy_ui_1.units)(2)};
    bottom: 0;
  }
`;
